import CallSplitIcon from '@mui/icons-material/CallSplit'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import MuiTableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'

const TableCell = styled(MuiTableCell)({
    border: 'none',
    fontSize: '0.8rem',
    padding: '4px 16px',
})

export default function FulfillmentTable({ data, enableSplit, onFulfillmentSplitClick }) {
    return (
        <TableContainer
            sx={{
                width: '70%',
                float: 'right',
                padding: '5px 0px 0px 15px',
                borderTop: `solid 1px`,
                borderTopColor: (theme) => theme.palette.grey[200],
            }}
        >
            {data.map((fulfillment, index) => (
                <Box
                    sx={{
                        '&:not(:first-of-type)': {
                            borderTop: 'solid 1px',
                            borderTopColor: (theme) => theme.palette.grey[200],
                        },
                    }}
                    key={index}
                    mb={0.5}
                >
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        p={2}
                        style={{ padding: '0 16px 0 0' }}
                    >
                        <Box display="flex" alignItems="center" justifyContent="flex-start">
                            <Typography
                                component="span"
                                variant="body2"
                                sx={{
                                    color: (theme) => theme.palette.grey[500],
                                    mr: 1,
                                    fontSize: '0.8rem',
                                }}
                            >
                                {gettext('Fulfillment')}
                            </Typography>
                            <Typography
                                component="span"
                                variant="body2"
                                sx={{
                                    color: (theme) => theme.palette.grey[500],
                                    mr: 1,
                                    fontSize: '0.8rem',
                                }}
                            >
                                {fulfillment.fulfillment_id}
                            </Typography>
                            {fulfillment.tracking_number && (
                                <Typography
                                    component="span"
                                    variant="body2"
                                    sx={{
                                        color: (theme) => theme.palette.grey[500],
                                        mr: 1,
                                        fontSize: '0.8rem',
                                    }}
                                >
                                    {gettext('Tracking')} {fulfillment.tracking_number}
                                </Typography>
                            )}
                            <Box
                                component="span"
                                sx={{
                                    border: 'solid 1px',
                                    borderColor: (theme) => theme.palette.grey[400],
                                    py: 0,
                                    px: 1,
                                    borderRadius: 1,
                                    color: (theme) => theme.palette.grey[500],
                                    fontSize: '0.8rem',
                                }}
                            >
                                {fulfillment.status_display_name}
                            </Box>
                        </Box>
                        <Box display="flex" alignItems="center">
                            <Typography
                                variant="body2"
                                color="textSecondary"
                                style={{ marginRight: 8 }}
                            >
                                {fulfillment.shipping_provider?.name}
                            </Typography>
                            {enableSplit && (
                                <IconButton
                                    onClick={onFulfillmentSplitClick}
                                    size="large"
                                    style={{ paddingTop: 4, paddingBottom: 4 }}
                                >
                                    <CallSplitIcon />
                                </IconButton>
                            )}
                        </Box>
                    </Box>
                    <Table>
                        <TableBody>
                            {fulfillment.fulfillment_line_items.map((item, itemIndex) => (
                                <TableRow key={itemIndex}>
                                    <TableCell sx={{ maxWidth: 40, width: 40, padding: 0 }}>
                                        <img src={item.image_url} style={{ width: 36 }} />
                                    </TableCell>
                                    <TableCell sx={{ width: 350 }}>
                                        {item.stock_record?.stock_item?.name}
                                    </TableCell>
                                    <TableCell
                                        sx={{ width: 150, textAlign: 'right', paddingRight: '8px' }}
                                    >
                                        {!!item.bundle_info && (
                                            <Box
                                                component="span"
                                                sx={{
                                                    border: 'solid 1px',
                                                    borderColor: (theme) => theme.palette.grey[400],
                                                    py: 0.3,
                                                    px: 1,
                                                    borderRadius: 1,
                                                    color: (theme) => theme.palette.grey[500],
                                                }}
                                            >
                                                {item.bundle_info.bundle_stock_item_sku}
                                            </Box>
                                        )}
                                    </TableCell>
                                    <TableCell
                                        sx={{ width: 60, textAlign: 'left', paddingLeft: '8px' }}
                                    >
                                        {!!item.bundle_info && (
                                            <Typography
                                                component="span"
                                                variant="body2"
                                                sx={{
                                                    color: (theme) => theme.palette.grey[500],
                                                    mr: 1,
                                                    fontSize: '0.8rem',
                                                }}
                                            >
                                                x{item.bundle_info.bundle_quantity}
                                            </Typography>
                                        )}
                                    </TableCell>
                                    <TableCell
                                        sx={{ width: 150, textAlign: 'right', paddingRight: '8px' }}
                                    >
                                        <Box
                                            component="span"
                                            sx={{
                                                border: 'solid 1px',
                                                borderColor: (theme) => theme.palette.grey[400],
                                                py: 0.3,
                                                px: 1,
                                                borderRadius: 1,
                                            }}
                                        >
                                            {item.stock_record?.stock_item?.sku}
                                        </Box>
                                    </TableCell>
                                    <TableCell
                                        sx={{ width: 60, textAlign: 'left', paddingLeft: '8px' }}
                                    >
                                        x{item.quantity}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Box>
            ))}
        </TableContainer>
    )
}
